import { useEffect } from "react"
import { useAuthTemplateContext } from "../context"

export default function useAuthTemplate(props: Props, dependencies: any[] = []) {
    const { setIsSocial, setFooter, setDescription } = useAuthTemplateContext()

    useEffect(() => {
        if (props.footer) setFooter(props.footer)
        if (props.social) setIsSocial(props.social)
        if (props.description) setDescription(props.description)

        return () => {
            setFooter(undefined)
            setIsSocial(undefined)
            setDescription(undefined)
        }
    }, dependencies)
}

interface Props {
    heading?: string
    footer?: React.ReactNode
    social?: boolean
    description?: React.ReactNode
}